export const formatTitle = (name)=>{
    return name.includes('@') ? name
      .split('@')[0]
      .replace(/\./g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase()) 
  : name;
  }